import React, { useEffect, useState } from 'react'
import { createContext } from 'react'
import { detectRegion, getStoredRegion, REGION_STORAGE_KEY, regions } from '../config/regions'

export const AuthContext = createContext()

const AuthProvider = ({ children }) => {

    const [cursor, setCursor] = useState('') // hidden fill
    const [regionCode, setRegionCode] = useState(() => getStoredRegion() || detectRegion())

    useEffect(() => {
        window.localStorage.setItem(REGION_STORAGE_KEY, regionCode)
    }, [regionCode])

    const selectRegion = (nextRegion) => {
        if (regions[nextRegion]) setRegionCode(nextRegion)
    }

    return (
        <AuthContext.Provider value={{
            setCursor,
            cursor,
            regionCode,
            region: regions[regionCode],
            selectRegion,
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider
